import { render, staticRenderFns } from "./LoginMail.vue?vue&type=template&id=49580a1e&"
import script from "./LoginMail.vue?vue&type=script&lang=js&"
export * from "./LoginMail.vue?vue&type=script&lang=js&"
import style0 from "./LoginMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports